import React from "react";
import _ from "lodash";
import { Skeleton } from "antd";

import { Transfer } from "misc/transfer";
import { useRoles } from "misc/api/keycloakApi";
import ConditionalWrapper from "misc/conditional/ConditionalWrapper";

const RolesTransfer = ({ client = null, ...props }) => {
    const { roles, isLoading } = useRoles({ suspense: true }, client);

    return (
        <ConditionalWrapper
            condition={isLoading}
            wrapper={children => (
                <Skeleton active paragraph={{ rows: 5 }}>
                    {children}
                </Skeleton>
            )}
        >
            <Transfer
                dataSource={roles
                    .filter(role => role.name.includes("role_") & (role.client === client))
                    .map(roles => ({
                        key: roles.id,
                        title: _.replace(roles.name, "role_", "")
                    }))}
                filterOption={(inputValue, option) => {
                    return option.title.toLowerCase().includes(inputValue.toLowerCase());
                }}
                {...props}
            />
        </ConditionalWrapper>
    );
};

export default RolesTransfer;
